import { useState } from "react";
import Theme from "../UI/Theme";
import UseWindowWidth from "../UI/CustomHooks/UseWindowWidth";
import MobileView from "./MobileView";
import Home from "./Home";
import InStay from "./InStay";
import CashBack from "./CashBack";
import CashForACause from "./CashForACause";
import CashForward from "./CashForward";
import { Container, Row } from "react-bootstrap";
import { rewardsOverviewText } from "../../settings/Constants";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";
import I18n from "../../translations/i18n";
import 'bootstrap/dist/css/bootstrap.min.css';

const StyledContainer = styled(Container)`
  font-family: ${({ theme }) => theme.secondaryFont};
`;

const StyledRow = styled(Row)`
  display: block;
  max-width: 950px;
  margin: 0 auto !important;
`;

const IntroText = styled.div`
  text-align: center;
  margin: 0 auto !important;

  ${({ type, darkMode }) =>
    type == "header" &&
    css`
      color: #${darkMode === "true" ? "FFFFFF" : "343638"};
      font-size: ${rem("34px")};
      font-weight: 500;
      line-height: ${rem("56px")};

      ${({ theme }) => theme.tablet`
      font-size: ${rem("24px")};
    `}
    `}

  ${({ type, darkMode }) =>
    type == "subheader" &&
    css`
      color: #${darkMode === "true" ? "C9C9C9" : "666666"};
      font-size: ${rem("20px")};
      font-weight: 400;

      ${({ theme }) => theme.tablet`
      font-size: ${rem("16px")};
    `}
    `}
`;

const NavBar = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: ${rem("1px")} solid #9f9f9f;
  margin: ${rem("43px")} ${rem("0px")} ${rem("39px")};
`;

const MenuItem = styled.span`
  cursor: pointer;
  font-size: ${rem("18px")};
  font-weight: 500;
  color: #9f9f9f;
  padding-bottom: ${rem("13px")};
  user-select: none;

  ${({ active, darkMode }) =>
    active &&
    css`
      color: #${darkMode === "true" ? "FFFFFF" : "343638"};
      border-bottom: ${rem("2px")} solid #343638;
    `}
`;

const MainContent = styled.div``;

const HotelRewardsOverview = ({
  widget,
  includeInstay,
  instayVouchers,
  coloredTiles,
  maxCashback,
  redemptionArray,
  singleVouchers,
  singleRedemptions,
  darkMode,
  currencyCode,
}) => {
  const [page, setPage] = useState(
    I18n.t("views.static_pages.rewards_overview_iframe.all")
  );

  const navItems = includeInstay
    ? rewardsOverviewText.navWithInstay
    : rewardsOverviewText.navWithoutInstay;
  let mobileView = UseWindowWidth() <= 768 ? true : false;

  const MainPageContent = (selectedPage) => {
    switch (selectedPage) {
      case I18n.t("views.static_pages.rewards_overview_iframe.all"):
        return (
          <Home
            includeInstay={includeInstay}
            coloredTiles={coloredTiles}
            primaryColor={widget.primary_color}
            widgetIdentifier={widget.widget_identifier}
            setPage={setPage}
            darkMode={darkMode}
          />
        );
      case "IN-STAY CASH":
        return (
          <InStay
            widgetIdentifier={widget.widget_identifier}
            instayVouchers={instayVouchers}
            coloredTiles={coloredTiles}
            primaryColor={widget.primary_color}
            darkMode={darkMode}
            currencyCode={currencyCode}
          />
        );
      case "CASH BACK":
        return (
          <CashBack
            widgetIdentifier={widget.widget_identifier}
            redemptionArray={redemptionArray}
            coloredTiles={coloredTiles}
            primaryColor={widget.primary_color}
            darkMode={darkMode}
          />
        );
      case "CASH FOR A CAUSE":
        return (
          <CashForACause
            widgetIdentifier={widget.widget_identifier}
            coloredTiles={coloredTiles}
            primaryColor={widget.primary_color}
            darkMode={darkMode}
          />
        );
      case "CASH FORWARD":
        return (
          <CashForward
            widgetIdentifier={widget.widget_identifier}
            maxCashback={maxCashback}
            coloredTiles={coloredTiles}
            primaryColor={widget.primary_color}
            darkMode={darkMode}
          />
        );
      default:
        return <Home />;
    }
  };

  return (
    <Theme>
      <StyledContainer fluid>
        <StyledRow>
          <IntroText type="header" darkMode={darkMode}>
            {rewardsOverviewText.introHeader}
          </IntroText>
          <IntroText type="subheader" darkMode={darkMode}>
            {rewardsOverviewText.introSubheader}
          </IntroText>
          {mobileView ? (
            <MobileView
              widgetIdentifier={widget.widget_identifier}
              includeInstay={includeInstay}
              maxCashback={maxCashback}
              singleVouchers={singleVouchers}
              singleRedemptions={singleRedemptions}
              darkMode={darkMode}
            />
          ) : (
            <>
              <NavBar>
                {navItems.map((menuItem) => (
                  <MenuItem
                    key={menuItem}
                    darkMode={darkMode}
                    active={menuItem === page}
                    onClick={() => setPage(menuItem)}
                  >
                    {menuItem}
                  </MenuItem>
                ))}
              </NavBar>
              <MainContent>{MainPageContent(page)}</MainContent>
            </>
          )}
        </StyledRow>
      </StyledContainer>
    </Theme>
  );
};

HotelRewardsOverview.propTypes = {
  widget: PropTypes.object.isRequired,
  includeInstay: PropTypes.bool.isRequired,
  instayVouchers: PropTypes.array,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  maxCashback: PropTypes.number.isRequired,
  redemptionArray: PropTypes.array.isRequired,
  singleVouchers: PropTypes.array.isRequired,
  singleRedemptions: PropTypes.array.isRequired,
  darkMode: PropTypes.string.isRequired,
};

export default HotelRewardsOverview;
